import React from "react";
import { ScrollToTop } from "../shared/components/ScrollToTop";
import SiteFooter from "./site-footer";
import SiteHeader from "./site-header";

type TRootLayoutProps = {
  children: React.ReactNode;
};

export default function RootLayout({ children }: TRootLayoutProps) {
  return (
    <>
      <SiteHeader />
      <main>{children}</main>
      <SiteFooter />
      <ScrollToTop />
    </>
  );
}
